import { ref, computed, type Ref } from "vue";
import { type FloorPlan, type TableStatus } from "@lemmonhq/types";
import { type FloorPlanViewMode } from "../tables-types";

export function useTableFilters(
  tables: Ref<TableStatus[]>,
  floorPlans: Ref<FloorPlan[]>,
  activeFloorPlan: Ref<string | undefined>,
  floorPlanViewMode: Ref<FloorPlanViewMode>,
) {
  const searchQuery = ref("");
  const filter = ref<"all" | "free" | "busy">("busy");

  const filteredTables = computed(() => {
    const isAllRooms = floorPlanViewMode.value === "all";
    let roomTableIds: Set<number> | null = null;
    if (!isAllRooms) {
      const activeFp = floorPlans.value.find(
        (fp) => fp.id === activeFloorPlan.value,
      );
      if (activeFp) {
        roomTableIds = new Set(
          activeFp.plan.filter((p) => p.tableId).map((p) => Number(p.tableId)),
        );
      }
    }

    return tables.value.filter((table) => {
      const matchesSearch = table.table.name
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase());

      const matchesFilter =
        filter.value === "all" ||
        (filter.value === "busy" && table.table.is_busy) ||
        (filter.value === "free" && !table.table.is_busy);

      const matchesRoom = !roomTableIds || roomTableIds.has(table.table.id);

      return matchesSearch && matchesFilter && matchesRoom;
    });
  });

  return { searchQuery, filter, filteredTables };
}
